const getIsBooster = (product) => ["creatine", "fiber", "collagen", "recovery"].includes(product);
const isAdditionalItem = (product) => [
    "waterbottle",
    "wb221",
    "wb222",
    "blenderbottle",
    "blender",
    "flavorboost",
    "additional_flavorboost",
    "flavor_boosts",
    "shirt",
    "high_nocaff_mango_10",
].includes(product);
const isAdditionalItemBtnTitle = (product) => [
    "waterbottle",
    "wb221",
    "wb222",
    "blenderbottle",
    "blender",
    "flavorboost",
    "additional_flavorboost",
    "shirt",
].includes(product);
const isFlavorBoost = (product) => ["flavorboost", "additional_flavorboost", "flavor_boosts"].includes(product);
const benefitsName = {
    creatine: "Our Creatine",
    fiber: "Formulated with",
    collagen: "Did you know?",
};
const benefitsDescription = {
    creatine: "is a science-backed, mono nutrient which also supports high-intensity training + energy production.",
    fiber: "a scientist-recommended dosage of beta glucan - a heart-healthy soluble fiber derived from oats.",
    collagen: "Collagen + Creatine pre-workout provides a 'nutrient-soup' to support your tendons.",
};
const getBagsOptions = (amount, bagOptions, item_type) => {
    const label = [
        "creatine",
        "preworkout",
        "collagen",
        "fiber",
        "recovery",
    ].includes(item_type)
        ? "3 Jars  (84 servings)"
        : "3 Bags (42 servings)";
    if (amount === 3) {
        bagOptions.push({
            label,
            value: "3",
        });
        return bagOptions;
    }
    return bagOptions;
};
const containerDetails = {
    creatine: { containerType: "Jars", servingType: "servings" },
    protein: { containerType: "Bags", servingType: "servings" },
    hydration: { containerType: "Bags", servingType: "single serving sticks" },
    preworkout: { containerType: "Jars", servingType: "servings" },
    collagen: { containerType: "Jars", servingType: "servings" },
    fiber: { containerType: "Jars", servingType: "servings" },
};
const getProductAccordionTitle = (itemType, currentIndex, totalLength) => `${itemType === "preworkout" ? "Jar" : "Bag"} ${currentIndex} of ${totalLength}`;
const bagOptions = {
    creatine: [
        { label: "1 Jar  (28 servings)", value: "1" },
        { label: "2 Jars  (56 servings)", value: "2" },
    ],
    protein: [
        { label: "1 Bag (14 servings)", value: "1" },
        { label: "2 Bags (28 servings)", value: "2" },
    ],
    hydration: [
        { label: "1 Bag (21 single serving sticks)", value: "1" },
        { label: "2 Bags (42 single serving sticks)", value: "2" },
    ],
    preworkout: [
        { label: "1 Jar (14 servings)", value: "1" },
        { label: "2 Jars (28 servings)", value: "2" },
    ],
    collagen: [
        { label: "1 Jar (14 servings)", value: "1" },
        { label: "2 Jars (28 servings)", value: "2" },
    ],
    fiber: [
        { label: "1 Jar (14 servings)", value: "1" },
        { label: "2 Jars (28 servings)", value: "2" },
    ],
    recovery: [
        { label: "1 Jar (28 servings)", value: "1" },
        { label: "2 Jars (56 servings)", value: "2" },
    ],
};
const bagOptionsV2 = {
    creatine: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
    ],
    protein: [
        { label: "14", value: "1" },
        { label: "28", value: "2" },
        { label: "42", value: "3" },
        { label: "56", value: "4" },
    ],
    hydration: [
        { label: "21", value: "1" },
        { label: "42", value: "2" },
        { label: "63", value: "3" },
        { label: "84", value: "4" },
    ],
    preworkout: [
        { label: "14", value: "1" },
        { label: "28", value: "2" },
        { label: "42", value: "3" },
        { label: "56", value: "4" },
    ],
    collagen: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
    ],
    fiber: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
    ],
    greens: [
        { label: "28", value: "1" },
        { label: "56", value: "2" },
        { label: "84", value: "3" },
        { label: "112", value: "4" },
    ],
    recovery: [
        { label: "28", value: "1" },
        { label: "56", value: "2" },
        { label: "84", value: "3" },
        { label: "112", value: "4" },
    ],
};
const bagAdvantageOptions = {
    creatine: [
        { label: "3 Jars  (84 servings)", value: "3" },
        { label: "4 Jars  (112 servings)", value: "4" },
        { label: "5 Jars  (84 servings)", value: "5" },
        { label: "6 Jars  (112 servings)", value: "6" },
    ],
    protein: [
        { label: "3 Bags (42 servings)", value: "3" },
        { label: "4 Bags (56 servings)", value: "4" },
        { label: "5 Bags (70 servings)", value: "5" },
        { label: "6 Bags (84 servings)", value: "6" },
    ],
    hydration: [
        { label: "3 Bags (63 single serving sticks)", value: "3" },
        { label: "4 Bags (84 single serving sticks)", value: "4" },
        { label: "5 Bags (105 single serving sticks)", value: "5" },
        { label: "6 Bags (126 single serving sticks)", value: "6" },
    ],
    preworkout: [
        { label: "3 Jars (42 servings)", value: "3" },
        { label: "4 Jars (56 servings)", value: "4" },
        { label: "5 Jars (70 servings)", value: "5" },
        { label: "6 Jars (84 servings)", value: "6" },
    ],
    collagen: [
        { label: "3 Jars (42 servings)", value: "3" },
        { label: "4 Jars (56 servings)", value: "4" },
        { label: "5 Jars (70 servings)", value: "5" },
        { label: "6 Jars (84 servings)", value: "6" },
    ],
    fiber: [
        { label: "3 Jars (42 servings)", value: "3" },
        { label: "4 Jars (56 servings)", value: "4" },
        { label: "5 Jars (70 servings)", value: "5" },
        { label: "6 Jars (84 servings)", value: "6" },
    ],
    greens: [
        { label: "3 Bags (84 servings)", value: "3" },
        { label: "4 Bags (112 servings)", value: "4" },
        { label: "5 Bags (140 servings)", value: "5" },
        { label: "6 Bags (168 servings)", value: "6" },
    ],
    recovery: [
        { label: "3 Jars (84 servings)", value: "3" },
        { label: "4 Jars (112 servings)", value: "4" },
        { label: "5 Jars (140 servings)", value: "5" },
        { label: "6 Jars (168 servings)", value: "6" },
    ],
};
const deliveryOptions = [
    { label: "Every 3 weeks", value: 3 },
    { label: "Every 4 weeks", value: 4 },
    { label: "Every 6 weeks", value: 6 },
    { label: "Every 8 weeks", value: 8 },
    { label: "Every 12 weeks", value: 12 },
];
const planOptions = [
    {
        label: "Advantage Plan",
        value: "advantage",
        description: "3 orders shipped together every 3 months",
        discount: 10,
    },
    {
        label: "Standard Plan",
        value: "standard",
        description: "1 order per shipment",
    },
];
const getSelectedFlavorString = (selectedFlavors, availableFlavors) => {
    if (selectedFlavors.length) {
        const selectedFlavorsArr = availableFlavors
            .map((item) => {
            const selectedItem = selectedFlavors.find((flavor) => flavor.short_name === item.short_name && flavor.count > 0);
            if (selectedItem) {
                return item.full_name;
            }
            return null;
        })
            .filter((item) => !!item);
        if (selectedFlavorsArr.length) {
            const string = `Flavors (${selectedFlavorsArr.length > 1
                ? selectedFlavorsArr.join(", ")
                : selectedFlavorsArr.join("")})`;
            return `${string.slice(0, 18)}...`;
        }
        return "No Flavors";
    }
    return "No Flavors";
};
const getOrderStatusStyles = (order) => {
    switch (order) {
        case "In Progress":
            return {
                color: "#77B1AC",
                backgroundColor: " linear-gradient(90.65deg, #77B1AC 0%, #99E2DB 100%)",
            };
        case "In Transit":
            return {
                color: "#91C479;",
                backgroundColor: "linear-gradient(90.65deg, #91C479 0%, #B5F796 100%)",
            };
        default:
            return {
                color: "#77B1AC",
                backgroundColor: "linear-gradient(90.65deg, #77B1AC 0%, #99E2DB 100%)",
            };
    }
};
export const uuid = () => "xxxx-xxxx".replace(/[x]/g, (c) => {
    const r = Math.random() * 16 || 0;
    const v = c === "x" ? r : (r && 0x3) || 0x8;
    return v.toString(16);
});
const isReactivationRoute = (location) => location.pathname.includes("modify") || location.pathname.includes("summary");
export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
export default {
    getIsBooster,
    benefitsName,
    benefitsDescription,
    bagOptions,
    bagAdvantageOptions,
    getSelectedFlavorString,
    getOrderStatusStyles,
    isAdditionalItem,
    getBagsOptions,
    isFlavorBoost,
    isReactivationRoute,
    containerDetails,
    deliveryOptions,
    planOptions,
    getProductAccordionTitle,
    isAdditionalItemBtnTitle,
    bagOptionsV2,
    capitalize,
};
